import { useEffect } from 'react';
import { useAuth } from '@clerk/nextjs';
import { useQueryClient } from 'react-query';
import { useSetAtom } from 'jotai';
import { failedLoginAtom, failedLoginMessageAtom, provisioningErrorHandledAtom } from 'auth/userStore';

export default function useAuthCleanup() {
  const { isLoaded, isSignedIn } = useAuth();
  const queryClient = useQueryClient();
  const setFailedLogin = useSetAtom(failedLoginAtom);
  const setFailedLoginMessage = useSetAtom(failedLoginMessageAtom);
  const setProvisioningHandled = useSetAtom(provisioningErrorHandledAtom);

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      // 1. clear React‑Query caches tied to the user
      queryClient.removeQueries('userDetails');
      queryClient.removeQueries('galacticaSessionOnEmpty');
      // 2. reset auth‑related atoms
      setFailedLogin(false);
      setFailedLoginMessage('');
      setProvisioningHandled(false);
    }
  }, [isLoaded, isSignedIn, queryClient]);
}
